export function parentZay($q, zaysServiceApiV2) {
  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ctrl) {
      ctrl.$asyncValidators.parentZay = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty model valid
          return $q.resolve()
        }

        const def = $q.defer()

        zaysServiceApiV2.get({ id: modelValue }).then((zay) => {
          if (zay.parent) {
            console.log('rejected' + zay.parent)

            def.reject()
          } else {
            def.resolve()
          }
        })

        return def.promise
      }
    },
  }
}
